// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC6i4L_2AwQQjXs61o2W0nU2KtbWlFBEm8",
  authDomain: "orpheus-dashboard.firebaseapp.com",
  projectId: "orpheus-dashboard",
  storageBucket: "orpheus-dashboard.firebasestorage.app",
  messagingSenderId: "567421918078",
  appId: "1:567421918078:web:5a4fc0a9b2cfbbe59d312f"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app; 
